import React, { useState, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import styles from './SpeedMathGame.module.css';
import Header from '../components/Header';
import SettingsModal from '../components/modals/SettingsModal';
import { useNavigate } from 'react-router-dom';
import SpeedMathBoard from './speedmath/SpeedMathBoard';

const SpeedMathGame = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [showGameListModal, setShowGameListModal] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showRestartModal, setShowRestartModal] = useState(false);

  const boardRef = useRef();

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShowShareModal(true);
    } catch (err) {
      alert('링크 복사에 실패했어요. 주소창의 URL을 직접 복사해주세요!');
      console.error('클립보드 복사 실패:', err);
    }
  };

  const handleRestart = () => {
    if (boardRef.current) {
      boardRef.current.resetGame();
      setShowRestartModal(false);
    }
  };

  return (
    <div className={styles.container}>
      <Header
        title={t('games.speedMath.title')}
        onGameList={() => setShowGameListModal(true)}
        onRules={() => setShowRulesModal(true)}
        onSettings={() => setShowSettingsModal(true)}
        onRestart={() => setShowRestartModal(true)}
      />

      <div className={styles.gameContainer}>
        <SpeedMathBoard ref={boardRef} />
      </div>

      {showGameListModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.gameList.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowGameListModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={() => navigate('/')}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRulesModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{t('games.speedMath.rules.title')}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>
              {t('games.speedMath.rules.description')}
            </p>
            <div className="modal-buttons">
              <button onClick={() => setShowRulesModal(false)}>
                {t('modals.rules.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettingsModal && (
        <SettingsModal
          onClose={() => setShowSettingsModal(false)}
          onContact={() => {
            setShowSettingsModal(false);
            setShowContactModal(true);
          }}
          onShare={handleShare}
        />
      )}

      {showContactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.contact.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowContactModal(false)}>
                {t('modals.contact.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareModal && (
        <div className="modal-overlay">
          <div className="modal share-modal">
            <p>{t('modals.share.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowShareModal(false)}>
                {t('modals.share.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRestartModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.restart.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowRestartModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={handleRestart}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpeedMathGame;
